import * as z from 'zod'
import type { AxiosRequestConfig } from 'axios';
import Rosettas from '@base/lib/rosettas'
import { ErrorAumentado } from '@base/lib/error'
import { ErrorNotificableZod, i18nIconos, i18nTapi } from '@base/lib/erroresNotificables'
import type { ResultadoDeSolicitudApi } from '@base/composables/tiposApi'
import { HashJson } from '@comun/hashU';

export function HeadersConAuth(tkn?: string): Record<string, string> {
  const elToken = tkn ?? unref(token)
  if (!elToken)
    throw new ErrorAumentado('noHayToken', { origen: 'HeadersConAuth', alertar: false })

  const headersBase = HeadersBase()
  return {
    ...headersBase,
    Authorization: `Bearer ${token.value}`
  }
}


export function HeadersBase(): Record<string, string> {
  const headers: {
    [key: string]: string
  } = {
    'Accept': 'application/json',
    'idioma': 'es',
    'gots-app': contextoApp.appConfig.appID,
    'gots-ambiente': contextoApp.buildConfig.modo,
    'gots-dispositivo': contextoApp.buildConfig.dispositivo,
    'gots-version': contextoApp.buildConfig.version
  }

  const usr = unref(usuario)

  if (usr && usr.marcaDeTiempo) headers['mdt-usr'] = usr.marcaDeTiempo

  return headers
}

const i18nAxios = Rosettas.crear({
  errorDeRed: {
    es: 'Error de red',
    en: 'Network error',
    pt: 'Erro de rede'
  },
  sinRespuesta: {
    es: 'Sin respuesta',
    en: 'No response',
    pt: 'Sem resposta'
  },
  malaConfiguracion: {
    es: 'Mala configuración',
    en: 'Bad configuration',
    pt: 'Má configuração'
  },
  noSePudoConectarConAPI: {
    es: 'No se pudo conectar con API',
    en: 'Could not connect to API',
    pt: 'Não foi possível conectar à API'
  },
  noAutorizado: {
    es: 'No autorizado',
    en: 'Unauthorized',
    pt: 'Não autorizado'
  },
  solicitudRechazada: {
    es: 'Solicitud rechazada',
    en: 'Request rejected',
    pt: 'Solicitação rejeitada'
  }
})

const RespuestaConErrorZod = z.object({
  ok: z.literal(false),
  error: z.string(),
  desconectar: z.literal(true).optional()
})

const appNoAutorizadaRef = ref(false)
export const appNoAutorizada = computed(() => appNoAutorizadaRef.value)

const appNoConectadaSQLRef = ref(false)
export const appNoConectadaSQL = computed(() => appNoConectadaSQLRef.value)

const appNoConectadaMongoDBRef = ref(false)
export const appNoConectadaMongoDB = computed(() => appNoConectadaMongoDBRef.value)

export function ManejadorErroresAxios(resultadoConError: unknown) {
  const fx = 'usoDiario ManejadorErroresAxios'

  consolo.log(fx, 'error', resultadoConError)

  if (!lodash.isObject(resultadoConError)) {
    throw new ErrorAumentado('errorExtraño');
  }
  if (lodash.isEmpty(resultadoConError)) {
    throw new ErrorAumentado('errorVacio');
  }

  // Verificar si hay respuesta disponible

  if (!('data' in resultadoConError)) {
    throw new ErrorAumentado('errorSinData');
  }

  if (!lodash.isObject(resultadoConError.data)) {
    throw new ErrorAumentado('respuestaExtraña');
  }

  if (lodash.isEmpty(resultadoConError.data)) {
    throw new ErrorAumentado('respuestaVacia');
  }
  if (!resultadoConError.data) {
    NotificacionesEnApp.error({
      titulo: i18nAxios('sinRespuesta'),
      texto: i18nAxios('noSePudoConectarConAPI'),
      codigo: 'sinRespuesta',
      duracionSegundos: 5,
      icono: 'solar:server-path-line-duotone',
      iconoMedida: '3rem'
    });
    throw new ErrorAumentado('sinRespuesta');
  }

  const elError = 'error' in resultadoConError.data ? resultadoConError.data.error : null
  if (!elError) return resultadoConError.data

  // Verificar si es un error de red
  if (elError === 'Network Error') {
    NotificacionesEnApp.error({
      titulo: i18nAxios('errorDeRed'),
      texto: i18nAxios('noSePudoConectarConAPI'),
      codigo: 'errorDeRed',
      duracionSegundos: 5,
      icono: 'arcticons:trexrunner',
      iconoMedida: '3rem'
    });
    // return
    throw new ErrorAumentado('sinConexion');
  }


  const errorParseo = RespuestaConErrorZod.safeParse(resultadoConError.data);

  if (!errorParseo.success) {
    throw new ErrorAumentado('respuestaConErrorMalParseada', { datos: { responseData: resultadoConError.data } });
  }

  const codigo = errorParseo.data.error;

  if (codigo === 'appNoAutorizada') {
    appNoAutorizadaRef.value = true;
  }

  const errorIDparseo = ErrorNotificableZod.safeParse(codigo)
  const errorNotificableID = errorIDparseo.success ? errorIDparseo.data : null

  if (errorNotificableID) {

    const errorBase: NotificacionData = {
      titulo: "Ups!",
      texto: i18nTapi(errorNotificableID),
      codigo: errorNotificableID,
      icono: i18nIconos[errorNotificableID]
    }

    console.error('errorID', errorNotificableID)

    if (['conexionFallidaSDB', 'conexionRechazadaSDB'].includes(errorNotificableID)) {
      appNoConectadaSQLRef.value = true
    }
    if (codigo === 'conexionFallidaDB') {
      appNoConectadaMongoDBRef.value = true
    }
    if (errorNotificableID === 'cuentaEliminada') {
      UsuarioAPI.CerrarSesion();
    }

    if (['conexionFallidaSDB', 'conexionRechazadaSDB', 'conexionFallidaDB'].includes(errorNotificableID)) {
      errorBase.titulo = i18nTapi('appDesactivada')
      NotificacionesEnApp.error(errorBase)
    } else if (['usuarioNoRegistrado', 'usuarioNoAutorizado'].includes(errorNotificableID)) {
      NotificacionesEnApp.error({
        titulo: i18nTapi(errorNotificableID),
        texto: errorParseo.data.desconectar ? i18nTapi('seHaCerradoLaSesion') : i18nTapi('seHaImpedidoElAcceso'),
        codigo: errorNotificableID,
        duracionSegundos: 3,
        icono: 'solar:ghost-outline',
        iconoMedida: '3rem'
      });

      UsuarioAPI.CerrarSesion();
      throw new ErrorAumentado('sinConexion');
    } else {
      consolo.warn('Error recibido no es notificable:', errorBase)
    }
  }
  return errorParseo.data;
}

type RespuestaDesconocidaPeroConUnOk = Record<string, unknown> & { ok: boolean, error?: string }

export async function comoSiFueraPorAxios(config: AxiosRequestConfig, opciones: { reportarError: boolean, skipIntegracion?: boolean } = { reportarError: true }): Promise<RespuestaDesconocidaPeroConUnOk> {
  const fx = 'comoSiFueraPorAxios[auth]'
  const timerID = `${MiniID()} ${fx}`
  try {
    consolo.log(timerID)
    // if (conLlavero) {
    const { llaveroCliente, registroID } = await LlaverosAPI.ObtenerLlaveros()

    appNoAutorizadaRef.value = false
    appNoConectadaSQLRef.value = false
    appNoConectadaMongoDBRef.value = false

    if (!config.url) {
      throw new Error('URL is required');
    }

    const fetchConfig: RequestInit = {
      method: config.method?.toUpperCase() || 'GET',
      headers: new Headers((config.headers ?? {}) as Record<string, string>)
    };

    // Agregar header idioma con el idioma actual
    const idiomaActual = unref(TrosettaAPI.idiomaVisible) || 'es'
    ;(fetchConfig.headers as Headers).append('idioma', idiomaActual)

    // IMPORTANTE: Calcular el hash del body DESPUÉS de serializarlo a JSON
    // para que coincida exactamente con lo que recibirá el servidor.
    // JSON.stringify elimina campos undefined, por lo que debemos calcular
    // el hash del objeto parseado para que coincida con el servidor.
    const bodyParaHash = config.data ? JSON.parse(JSON.stringify(config.data)) : {}
    const hashDelBody = await HashJson(bodyParaHash)
    const signatura = await llaveroCliente.firmar({ hash: hashDelBody, iss: llaveroCliente.llaveroID, rid: registroID });
    (fetchConfig.headers as Headers).append('signatura', signatura)

    if (config.data) {
      // Convert data to JSON before assigning to body
      fetchConfig.body = JSON.stringify(config.data);
      (fetchConfig.headers as Headers).append('Content-Type', 'application/json')
    }

    // * Ejecucion de solicitud
    const response = await fetch(config.url, fetchConfig);

    const dataRespuesta = await response.json();
    const headersRespuesta: Partial<Headers> = lodash.pickBy(response.headers, (value) => typeof value === 'string');
    const comoEnAxios: ResultadoDeSolicitudApi = {
      success: true,
      data: dataRespuesta,
      status: response.status,
      statusText: response.statusText,
      headers: headersRespuesta
    };

    if (!dataRespuesta.ok) {
      // Verificar si el servidor solicita rotar el llavero
      if (dataRespuesta.rotarLlavero === true) {
        consolo.log('[axiosWorkerAPI] Servidor solicita rotar llavero, rotando...')
        await LlaverosAPI.RotarLlavero()
        // Reintentar la solicitud después de rotar
        return await comoSiFueraPorAxios(config, opciones)
      }
      ManejadorErroresAxios(comoEnAxios)
    }

    if (!opciones.skipIntegracion) {
      await IntegrarElementosFrescos({
        url: config.url,
        fetchConfig,
        dataRecibida: dataRespuesta
      })
    }

    return dataRespuesta;
  } catch (error) {
    console.error(timerID, 'catch', error);
    console.error('JSON error', JSON.stringify(error));


    const errorString = error instanceof Error ? error.message : 'Unknown error';
    return {
      ok: false,
      error: errorString
    }
  }
}
